import { 
  LayoutDashboard, 
  Users, 
  Backpack, 
  CalendarDays, 
  Receipt, 
  Settings,
  Shield,
  Calendar,
  BarChart2,
  HelpCircle,
  MessageSquare,
  FileText,
  ClipboardSignature,
  CalendarClock,
  BookOpen,
  CreditCard,
  Video,
  UserCog,
  Radio
} from 'lucide-react';

export const adminNavItems = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/families", icon: Users, label: "Families" },
  { to: "/classes", icon: Backpack, label: "Classes" },
  { to: "/schedule", icon: CalendarDays, label: "Schedule" },
  { to: "/invoices", icon: Receipt, label: "Invoices" },
  { to: "/admin/billing-schedules", icon: CreditCard, label: "Auto-Billing" },
  { to: "/reporting", icon: BarChart2, label: "Reporting" },
  { to: "/seasons", icon: Calendar, label: "Seasons" },
  { to: "/settings", icon: Settings, label: "Settings" },
  { to: "/admin/subscription-center", icon: CreditCard, label: "Subscription Center" }
];

export const parentNavItems = [
  { to: "/parent-portal", icon: LayoutDashboard, label: "Home" },
  { to: "/parent-portal/classes", icon: Backpack, label: "Classes" },
  { to: "/parent-portal/schedule", icon: CalendarDays, label: "Schedule" },
  { to: "/parent-portal/messages", icon: MessageSquare, label: "Messages" },
  { to: "/parent-portal/billing", icon: Receipt, label: "Billing" },
  { to: "/parent-portal/documents", icon: FileText, label: "Documents" },
  { to: "/parent-portal/policies", icon: ClipboardSignature, label: "Policies" },
  { to: "/parent-portal/makeups", icon: CalendarClock, label: "Makeup Classes" },
  { to: "/parent-portal/available-courses", icon: BookOpen, label: "Available Classes" }
];

export const commonNavItems = [
  { to: "/help", icon: HelpCircle, label: "Help & Support" }
];

export const superUserNavItems = [
  { to: "/superadmin", icon: Shield, label: "SuperAdmin", className: "text-yellow-600" },
  { to: "/superadmin/subscription-management", icon: Receipt, label: "Subscription Plans", className: "text-yellow-600" }
];

export const hiveShareNavItems = [
  { to: "/admin/hiveshare", icon: Video, label: "Videos" },
  { to: "/admin/live-stream", icon: Radio, label: "Live Stream" },
  { to: "/admin/families", icon: Users, label: "Families" },
  { to: "/admin/staff", icon: UserCog, label: "Team" }
];
